<ng-container>
    <div class="container-fluid audit-content px-0 pe-0">
        <hr class="m-0">
        <div class="py-2">
            <p class="audit-title px-2">Audit Reports</p>
        </div>
        <lib-audit-report-header
            [enterpriseLabels]="enterpriseLabels" (reloadAuditReportData)="emitReloadData()">
        </lib-audit-report-header>
        <lib-audit-report-table *ngIf="enterpriseLabels"
            [enterpriseLabels]="enterpriseLabels" [reloadDataObs]="reloadDataSubject.asObservable()">
        </lib-audit-report-table>
    </div>
</ng-container>
